import React from 'react';
import IconButton from './IconButton';

export const ProductBuyButtonsV2 = (props: {
  cartQuantity: number;
  onDecrementClick: () => void;
  onIncrementClick: () => void;
  minimumUnitPurchase: number | null;
}) => {
  const {
    cartQuantity,
    onDecrementClick,
    onIncrementClick,
    minimumUnitPurchase,
  } = props;
  return (
    <>
      <IconButton
        solid
        disabled={cartQuantity === 0}
        onClick={onDecrementClick}
        aria-label={'Reduce quantity by ' + (minimumUnitPurchase || 1)}
        className="ww-product-buy-buttons-decrement"
      >
        {(minimumUnitPurchase || 1) == 1 ? (
          <i className="icon-minus" />
        ) : (
          '-' + (minimumUnitPurchase || 1)
        )}
      </IconButton>
      <span className="quantity ww-product-buy-buttons-quantity font-bold">
        {cartQuantity}
      </span>
      <IconButton
        solid
        onClick={onIncrementClick}
        aria-label={'Increase quantity by ' + (minimumUnitPurchase || 1)}
        className="ww-product-buy-buttons-increment"
      >
        {(minimumUnitPurchase || 1) == 1 ? (
          <i className="icon-plus" />
        ) : (
          '+' + (minimumUnitPurchase || 1)
        )}
      </IconButton>
    </>
  );
};
